import { createStore } from "./_createStore";

type GlobalErrorState = {
  isErrorAlertOpen: boolean;
  setGlobalError: (
    state: Partial<Omit<GlobalErrorState, "setGlobalError">>,
  ) => void;
};

export const useGlobalErrorStore = createStore<GlobalErrorState>(
  (set) => ({
    isErrorAlertOpen: false,
    setGlobalError: (state) => set(state),
  }),
  "GlobalErrorStore",
);
